import React from 'react';

const BranchDetails = ({ branch }) => {
  if (!branch) {
    return (
      <div className="text-center text-gray-500 py-8">
        Select a branch to view details
      </div>
    );
  }

  return (
    <div>
      <div className="mt-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Branch Name</label>
          <div className="mt-1 text-gray-900">{branch.name}</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Location</label>
          <div className="mt-1 text-gray-900">{branch.location}</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Manager Email</label>
          <div className="mt-1 text-gray-900">{branch.manager}</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Manager Phone</label>
          <div className="mt-1 text-gray-900">{branch.managerPhone}</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Status</label>
          <div className="mt-1">
            <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
              branch.state === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'
            }`}>
              {branch.state}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchDetails;